import lightstep from 'lightstep-tracer/browser'

export const tracer = new lightstep.Tracer({
  access_token: process.env.REACT_APP_TRACER_API_KEY || '',
  component_name: 'sf-ui-webapp',
})
